import CartItemSlot from '../CartItemSlot';
import threePackImage from './img/sentinel-ble-3-pack.jpg';
import sentinelImage from './img/sentinelx-image-charcoal.jpg';
const cartItemsBle = new Map();
cartItemsBle.set(CartItemSlot.Primary, {
    COGS: 5.75,
    defaultAdd: true,
    image: sentinelImage,
    msrp: 50,
    planId: 'XYO-SENTINEL-X-CHAR',
    price: 0,
    quantity: 1,
    ship: true,
    subtitle: '(Normal Price: $50)',
    title: '1 SentinelX BLE Device: Free',
    value: 0,
});
cartItemsBle.set(CartItemSlot.Shipping, {
    COGS: 5,
    defaultAdd: true,
    msrp: 12.95,
    planId: 'XY-SHIPPING-FULL-2',
    price: 12.95,
    quantity: 1,
    ship: true,
    subtitle: '(Non-US $17.95)',
    title: 'Shipping Cost: $12.95 (price you pay)',
    value: 12.95,
});
cartItemsBle.set(CartItemSlot.ShippingIntl, {
    COGS: 10,
    msrp: 17.95,
    planId: 'XY-SHIPPING-INTL-1',
    price: 17.95,
    quantity: 1,
    ship: true,
    subtitle: '(US $12.95)',
    title: 'Shipping Cost: $17.95 (price you pay)',
    value: 17.95,
});
cartItemsBle.set(CartItemSlot.Trial, {
    COGS: 0,
    defaultAdd: true,
    planId: 'XYO-COIN-PRO-3D-TRIAL-34-95',
    planType: 'COIN Pro',
    price: 0,
    quantity: 1,
    ship: false,
    value: 42,
});
cartItemsBle.set(CartItemSlot.Subscription, {
    COGS: 0,
    planId: 'XYO-COIN-PRO-34-95',
    planType: 'COIN Pro',
    price: 34.95,
    quantity: 1,
    ship: false,
    value: 34.95,
});
cartItemsBle.set(CartItemSlot.Upsell, {
    COGS: 17.25,
    image: threePackImage,
    planId: 'XYO-SENTINEL-X-WYP-3-PACK',
    price: 67,
    quantity: 1,
    ship: true,
    value: 67,
});
cartItemsBle.set(CartItemSlot.SemiAnnual, {
    COGS: 0,
    planId: 'COIN-PRO-SEMIANNUAL-PLAN-110-82',
    planType: 'COIN Pro',
    price: 110.82,
    quantity: 1,
    ship: false,
    value: 110.82,
});
export default cartItemsBle;
//# sourceMappingURL=cartItemsBle.js.map